import React from 'react'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const EnableKosningDialog = (props) => {
  const { dialogOpen, setDialogOpen, selectedKosning, handleEnableKosning } = props;

  const handleClose = () => {
    setDialogOpen(false);
  }

  if (selectedKosning === null) {
    return null;
  }

  return (
    <div>
      <Dialog
        open={dialogOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Opna fyrir skráningu"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Ertu viss um að þú viljir opna fyrir skráningu í<br /> <strong>{selectedKosning.lysing}</strong>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Nei
          </Button>
          <Button onClick={handleEnableKosning}  color="primary" autoFocus>
            Já
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default EnableKosningDialog;
